module.exports = __webpack_public_path__ + "wappen.png?63eb842e07232f31c173cbb162675312";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wappen.png
// module id = 647
// module chunks = 0